import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/story", label: "Story" },
  { to: "/sustainability", label: "Sustainability" },
];

const darkHeroPaths = ["/sustainability"];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  const isHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [pathname]);

  const isDarkHero = darkHeroPaths.includes(pathname);
  const darkOnInitial = isDarkHero && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-bone/90 backdrop-blur-md border-b border-ink/5" : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-10 h-16 md:h-20">
        <Link
          to="/"
          className={`font-display text-2xl md:text-[28px] tracking-tightest leading-none ${
            darkOnInitial ? "text-bone" : "text-ink"
          }`}
        >
          Verdant<span className="text-rust">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `nav-link text-[13px] tracking-wide uppercase font-medium cursor-pointer whitespace-nowrap ${
                  darkOnInitial ? "text-bone" : "text-ink"
                } ${isActive ? "opacity-100" : "opacity-80 hover:opacity-100"}`
              }
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-5">
          <button
            aria-label="Search"
            className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              darkOnInitial ? "text-bone hover:bg-white/10" : "text-ink hover:bg-ink/5"
            }`}
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <button
            aria-label="Bag"
            className={`flex items-center gap-2 text-[13px] uppercase font-medium tracking-wide cursor-pointer whitespace-nowrap ${
              darkOnInitial ? "text-bone" : "text-ink"
            }`}
          >
            <i className="ri-shopping-bag-line text-lg"></i>
            <span>Bag (0)</span>
          </button>
        </div>

        <button
          aria-label="Menu"
          onClick={() => setMobileOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer ${
            darkOnInitial ? "text-bone" : "text-ink"
          }`}
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-bone border-t border-ink/10 px-6 py-6">
          <nav className="flex flex-col gap-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className="font-display text-2xl text-ink cursor-pointer"
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-6 pt-6 border-t border-ink/10 flex items-center gap-6 text-ink text-sm">
            <span className="flex items-center gap-2 cursor-pointer"><i className="ri-search-line"></i> Search</span>
            <span className="flex items-center gap-2 cursor-pointer"><i className="ri-shopping-bag-line"></i> Bag (0)</span>
          </div>
        </div>
      )}
    </header>
  );
}